<template>
  <div v-if="!notif.component"
       :class="`p-4 bg-${bgcolor}`"><!--領域全体のパディング -->

    <div class="flex items-start">
      <!-- 本体 -->
      <div class="ml-3 w-0 flex-1">
        <p :class="`font-semibold mb-2 text-${color}`">{{ notif.title }}</p>
        <p :class="`text-sm font-semibold text-${color}`">{{ notif.text }}</p>
      </div>

      <!-- キャンセルボタン -->
      <div v-if="notif.hasClose" class="flex ml-4 shrink-0">
        <button @click="close(notif.id)" :class="`inline-flex text-${color} bg-${bgcolor} rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 hover:text-gray-400 focus:ring-gray-300`">
          <span class="sr-only">Close</span>
          <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

    </div>
  </div>

  <!--componentが指定されている時はそれをそのまま表示する-->
  <div>
    <component :is="notif.component" @close="close(notif.id)"/>
  </div>
</template>

<script setup lang="ts">
import {NotificationSchema} from './zNotify';
const props = defineProps<{close: (string)=>void, notif: NotificationSchema }>();

const bgcolor = props.notif.bgcolor ? props.notif.bgcolor : 'white';
const color = props.notif.color ? props.notif.color : 'black';
</script>


<style lang="postcss" scoped>
</style>
